import { defaultNumberFormat as configuredDefaultNumberFormat } from "src/../src-dynamic/destination.config";

export const NUMBER_FORMATS = {
  COMMA_DOT: "#,###.##",
  SPACE_DOT: "# ###.##",
  DOT_COMMA: "#.###,##",
};

export function normalizeDefaultNumberFormat(format) {
  const resolvedFormat = typeof format === "string" ? format : format?.format;

  if (resolvedFormat === NUMBER_FORMATS.COMMA_DOT) return NUMBER_FORMATS.COMMA_DOT;
  if (resolvedFormat === NUMBER_FORMATS.SPACE_DOT) return NUMBER_FORMATS.SPACE_DOT;
  if (resolvedFormat === NUMBER_FORMATS.DOT_COMMA) return NUMBER_FORMATS.DOT_COMMA;
  return null;
}

export function getDefaultNumberFormat() {
  return normalizeDefaultNumberFormat(configuredDefaultNumberFormat);
}

export function getNumberFormatSeparators(format = getDefaultNumberFormat()) {
  if (format === NUMBER_FORMATS.COMMA_DOT) return { separator: ",", decimal: "." };
  if (format === NUMBER_FORMATS.SPACE_DOT) return { separator: " ", decimal: "." };
  if (format === NUMBER_FORMATS.DOT_COMMA) return { separator: ".", decimal: "," };
  return null;
}
